export default __webpack_public_path__ + "static/media/constani.37ce4a90.ttf";